import PhoneNumberField from "../Utility/PhoneDropdown";

export const signUpFormFields = (industryTypes = []) => [
  {
    type: "text",
    name: "firstName",
    label: <span className="custom-label">First Name</span>,
    className: "custom-input",
    rules: [{ required: true, max: 15, min: 2, message: "Please enter a valid first name." }],
    placeholder: "John",
  },
  {
    type: "text",
    name: "lastName",
    label: <span className="custom-label">Last Name</span>,
    className: "custom-input",
    rules: [{ required: true, max: 15, min: 2, message: "Please enter a valid last name." }],
    placeholder: "Doe",
  },
  {
    type: "text",
    name: "name",
    label: <span className="custom-label">Company Name</span>,
    className: "custom-input",
    rules: [{ required: true, max: 40, min: 2, message: "Please enter a valid company name." }],
    placeholder: "SJ Innovation LLC",
  },
  {
    type: "custom",
    name: "phoneNumber",
    label: <span className="custom-label">Phone Number</span>,
    className: "custom-input",
    component: PhoneNumberField,
    rules: [{ required: true, message: "Phone number is required." }],
  },
  {
    type: "select",
    name: "industry",
    label: <span className="custom-label">Choose Your Industry</span>,
    dropdownStyle: { backgroundColor: "#E7E7E7", color: "#000" },
    className: "industry-field", 
    options: industryTypes.map((industry) => ({
      label: industry.name, 
      value: industry.name
    })),
    rules: [{ required: true, message: "Industry is required." }],
  },
  {
    type: "text",
    name: "email",
    label: <span className="custom-label">Email</span>,
    className: "custom-input",
    rules: [
      { required: true, message: "Please enter your email address." },
      { pattern: /^[^\s@]+@[^\s@]+\.[^\s@]+$/, message: "Please enter a valid email address." }],
    placeholder: "Admin Email",
  },
  {
    type: "password",
    name: "password",
    label: <span className="custom-label">Password</span>,
    className: "custom-input",
    rules: [
      { required: true, min: 8, message: "Please enter a minimum 8-character password." },
      { pattern: /^\S*$/, message: "Password cannot contain spaces." }],
    placeholder: "Admin Password",
  },
  {
    name: "terms",
    type: "checkbox",
    label: (
      <span style={{ color: "rgb(87, 91, 97)" }}>
        I agree to the{" "}
        <a
          href="/terms-and-condition"
          target="_blank"
          rel="noopener noreferrer"
          style={{ color: "rgb(87, 91, 97)", textDecoration: "underline" }}
        >
          Terms and Conditions
        </a>
      </span>
    ),
    rules: [{ required: true, message: "You must agree to the Terms and Conditions!" }],
  },
  {
    name: "privacy",
    type: "checkbox",
    label: (
      <span style={{ color: "rgb(87, 91, 97)" }}>
        I agree to the{" "}
        <a
          href="/security-data-privacy"
          target="_blank"
          rel="noopener noreferrer"
          style={{ color:  "rgb(87, 91, 97)", textDecoration: "underline" }}
        >
          Privacy Policy
        </a>
      </span>
    ),
    rules: [{ required: true, message: "You must agree to the Privacy Policy!" }],
  },
  // {
  //   name: "submit",
  //   label: "Sign up",
  //   type: "submit",
  //   htmlType: "submit",
  //   className: "btn-primary mt-4",
  //   buttonType: "primary",
  //   block: true,
  // },
];